import restful from '@/utils/restful';
import * as names from '@/store/names';
import * as get from '@/store/store';

const state = {
    study_environments: [],
    study_environments_url: '/mesh/study-environment',
    study_environments_time_allocation: [],
    study_environments_time_allocation_url: '/mesh/study-environment-time-allocation',
    matter_study_environments: [],
    matter_study_environments_url: '/mesh/matter-study-environment',
    egress_profile_matter_study_environments: [],
    egress_profile_matter_study_environments_url: '/mesh/egress-profile-matter-study-environment'
}

const getters = {
    [names.STUDY_ENVIRONMENTS]: state => {
        if (!get.store.state.user) return [];
        return state.study_environments.filter((x) => x.school == get.store.state.user.school).sort((a, b) => a.id - b.id);
    },
    [names.STUDY_ENVIRONMENTS_TIME_ALLOCATION]: state => {
        if (!get.store.state.user) return [];
        return state.study_environments_time_allocation.filter((x) => x.school == get.store.state.user.school).sort((a, b) => a.id - b.id);
    },
    [names.MATTER_STUDY_ENVIRONMENTS]: state => {
        return state.matter_study_environments;
    },
    [names.EGRESS_PROFILE_MATTER_STUDY_ENVIRONMENTS]: state => {
        return state.egress_profile_matter_study_environments;
    },
}

const mutations = {
    [names.MUTATE_STUDY_ENVIRONMENTS]: (state, study_environments) => {
        study_environments.forEach(element => {
            let index = state.study_environments.findIndex(x => x.id == element.id);
            if (index != -1) state.study_environments.splice(index, 1, element);
            else state.study_environments.push(element);
        });
    },
    [names.MUTATE_STUDY_ENVIRONMENT]: (state, study_environment) => {
        let index = state.study_environments.findIndex(x => x.id == study_environment.id);
        if (index != -1) state.study_environments.splice(index, 1, study_environment);
        else state.study_environments.push(study_environment);
    },
    [names.MUTATE_DELETE_STUDY_ENVIRONMENT]: (state, study_environment_id) => {
        let index = state.study_environments.findIndex(x => x.id == study_environment_id);
        if (index != -1) state.study_environments.splice(index, 1);
    },
    // study_enviroment_time_allocation
    [names.MUTATE_STUDY_ENVIRONMENTS_TIME_ALLOCATION]: (state, study_environments_time_allocation) => {
        study_environments_time_allocation.forEach(element => {
            let index = state.study_environments_time_allocation.findIndex(x => x.id == element.id);
            if (index != -1) state.study_environments_time_allocation.splice(index, 1, element);
            else state.study_environments_time_allocation.push(element);
        });
    },
    [names.MUTATE_STUDY_ENVIRONMENT_TIME_ALLOCATION]: (state, study_environment_time_allocation) => {
        let index = state.study_environments_time_allocation.findIndex(x => x.id == study_environment_time_allocation.id);
        if (index != -1) state.study_environments_time_allocation.splice(index, 1, study_environment_time_allocation);
        else state.study_environments_time_allocation.push(study_environment_time_allocation);
    },
    [names.MUTATE_DELETE_STUDY_ENVIRONMENT_TIME_ALLOCATION]: (state, study_environment_time_allocation_id) => {
        let index = state.study_environments_time_allocation.findIndex(x => x.id == study_environment_time_allocation_id);
        if (index != -1) state.study_environments_time_allocation.splice(index, 1);
    },
    // matter_study_environments
    [names.MUTATE_MATTER_STUDY_ENVIRONMENTS]: (state, matter_study_environments) => {
        matter_study_environments.forEach(element => {
            let index = state.matter_study_environments.findIndex(x => x.id == element.id);
            if (index != -1) state.matter_study_environments.splice(index, 1, element);
            else state.matter_study_environments.push(element);
        });
    },
    [names.MUTATE_MATTER_STUDY_ENVIRONMENT]: (state, matter_study_environment) => {
        let index = state.matter_study_environments.findIndex(x => x.id == matter_study_environment.id);
        if (index != -1) state.matter_study_environments.splice(index, 1, matter_study_environment);
        else state.matter_study_environments.push(matter_study_environment);
    },
    [names.MUTATE_DELETE_MATTER_STUDY_ENVIRONMENT]: (state, matter_study_environment_id) => {
        let index = state.matter_study_environments.findIndex(x => x.id == matter_study_environment_id);
        if (index != -1) state.matter_study_environments.splice(index, 1);
    },
    // egress_profile_matter_study_environments
    [names.MUTATE_EGRESS_PROFILE_MATTER_STUDY_ENVIRONMENTS]: (state, egress_profile_matter_study_environments) => {
        egress_profile_matter_study_environments.forEach(element => {
            let index = state.egress_profile_matter_study_environments.findIndex(x => x.id == element.id);
            if (index != -1) state.egress_profile_matter_study_environments.splice(index, 1, element);
            else state.egress_profile_matter_study_environments.push(element);
        });
    },
    [names.MUTATE_EGRESS_PROFILE_MATTER_STUDY_ENVIRONMENT]: (state, egress_profile_matter_study_environment) => {
        let index = state.egress_profile_matter_study_environments.findIndex(x => x.id == egress_profile_matter_study_environment.id);
        if (index != -1) state.egress_profile_matter_study_environments.splice(index, 1, egress_profile_matter_study_environment);
        else state.egress_profile_matter_study_environments.push(egress_profile_matter_study_environment);
    },
    [names.MUTATE_DELETE_EGRESS_PROFILE_MATTER_STUDY_ENVIRONMENT]: (state, egress_profile_matter_study_environment_id) => {
        let index = state.egress_profile_matter_study_environments.findIndex(x => x.id == egress_profile_matter_study_environment_id);
        if (index != -1) state.egress_profile_matter_study_environments.splice(index, 1);
    },
}

const actions = {
    [names.FETCH_STUDY_ENVIRONMENT]: ({
        commit,
        state
    }, study_environment_id) => {
        return new Promise((resolve) => {
            restful.Get(`${state.study_environments_url}/${study_environment_id}/`)
                .then(response => {
                    commit(names.MUTATE_STUDY_ENVIRONMENT, response);
                    resolve(response);
                });
        });
    },
    [names.FETCH_STUDY_ENVIRONMENTS]: ({
        commit,
        state,
    }, force) => {
        return new Promise((resolve) => {
            if (!force && state.study_environments.length > 0) {
                resolve(state.study_environments);
                return;
            }
            restful.GetAll(`${state.study_environments_url}/`)
                .then(response => {
                    commit(names.MUTATE_STUDY_ENVIRONMENTS, response);
                    resolve(response);
                });
        });
    },
    [names.POST_STUDY_ENVIRONMENT]: ({
        commit,
        state
    }, study_environment) => {
        return new Promise((resolve) => {
            restful.Post(`${state.study_environments_url}/`, study_environment)
                .then(response => {
                    commit(names.MUTATE_STUDY_ENVIRONMENT, response);
                    resolve(response);
                });
        });
    },
    [names.UPDATE_STUDY_ENVIRONMENT]: ({
        commit,
        state
    }, study_environment) => {
        return new Promise((resolve) => {
            restful.Put(`${state.study_environments_url}/${study_environment.id}/`, study_environment)
                .then(response => {
                    commit(names.MUTATE_STUDY_ENVIRONMENT, response);
                    resolve(response);
                });
        });
    },
    [names.PATCH_STUDY_ENVIRONMENT]: ({
        commit,
        state
    }, payload) => {
        return new Promise((resolve) => {
            restful.Patch(`${state.study_environments_url}/${payload.study_environment_id}/`, payload.item)
                .then(response => {
                    commit(names.MUTATE_STUDY_ENVIRONMENT, response);
                    resolve(response);
                });
        });
    },
    [names.DELETE_STUDY_ENVIRONMENT]: ({
        commit,
        state
    }, study_environment_id) => {
        return new Promise((resolve) => {
            restful.Delete(`${state.study_environments_url}/${study_environment_id}/`)
                .then(response => {
                    commit("MUTATE_DELETE__STUDY_ENVIRONMENT_BY_EGRESS_PROFILE_MATTERS", study_environment_id);
                    commit("MUTATE_DELETE__STUDY_ENVIRONMENT_BY_MATTERS", study_environment_id);
                    commit(names.MUTATE_DELETE_STUDY_ENVIRONMENT, study_environment_id);
                    resolve(response);
                });
        });
    },
    // study_enviroment_time_allocation
    [names.FETCH_STUDY_ENVIRONMENT_TIME_ALLOCATION]: ({
        commit,
        state
    }, study_environment_time_allocation_id) => {
        return new Promise((resolve) => {
            restful.Get(`${state.study_environments_time_allocation_url}/${study_environment_time_allocation_id}/`)
                .then(response => {
                    commit(names.MUTATE_STUDY_ENVIRONMENT_TIME_ALLOCATION, response);
                    resolve(response);
                });
        });
    },
    [names.FETCH_STUDY_ENVIRONMENTS_TIME_ALLOCATION]: ({
        commit,
        state,
    }, payload) => {
        return new Promise((resolve) => {
            let url_append = '';
            if (payload) {
                if (payload.study_environment) {
                    if (state.study_environments_time_allocation.filter(x => x.study_environment == payload.study_environment).length > 0) {
                        resolve(state.study_environments_time_allocation.filter(x => x.study_environment == payload.study_environment))
                        return;
                    } else
                        url_append += '?study_environment=' + payload.study_environment;
                } else
                    if (payload.time_allocation) {
                        if (state.study_environments_time_allocation.filter(x => x.time_allocation == payload.time_allocation).length > 0) {
                            resolve(state.study_environments_time_allocation.filter(x => x.time_allocation == payload.time_allocation))
                            return;
                        } else
                            url_append += '?time_allocation=' + payload.time_allocation;
                    }
            } else if (state.study_environments_time_allocation.length > 0) {
                resolve(state.study_environments_time_allocation);
                return;
            }
            restful.GetAll(`${state.study_environments_time_allocation_url}/${url_append}`)
                .then(response => {
                    commit(names.MUTATE_STUDY_ENVIRONMENTS_TIME_ALLOCATION, response);
                    resolve(response);
                });
        });
    },
    [names.POST_STUDY_ENVIRONMENT_TIME_ALLOCATION]: ({
        commit,
        state
    }, study_environment) => {
        return new Promise((resolve) => {
            restful.Post(`${state.study_environments_time_allocation_url}/`, study_environment)
                .then(response => {
                    commit(names.MUTATE_STUDY_ENVIRONMENT_TIME_ALLOCATION, response);
                    resolve(response);
                });
        });
    },
    [names.UPDATE_STUDY_ENVIRONMENT_TIME_ALLOCATION]: ({
        commit,
        state
    }, study_environment) => {
        return new Promise((resolve) => {
            restful.Put(`${state.study_environments_time_allocation_url}/${study_environment.id}/`, study_environment)
                .then(response => {
                    commit(names.MUTATE_STUDY_ENVIRONMENT_TIME_ALLOCATION, response);
                    resolve(response);
                });
        });
    },
    [names.PATCH_STUDY_ENVIRONMENT_TIME_ALLOCATION]: ({
        commit,
        state
    }, payload) => {
        return new Promise((resolve) => {
            restful.Patch(`${state.study_environments_time_allocation_url}/${payload.study_environment_time_allocation_id}/`, payload.item)
                .then(response => {
                    commit(names.MUTATE_STUDY_ENVIRONMENT_TIME_ALLOCATION, response);
                    resolve(response);
                });
        });
    },
    [names.DELETE_STUDY_ENVIRONMENT_TIME_ALLOCATION]: ({
        commit,
        state
    }, study_environment_time_allocation_id) => {
        return new Promise((resolve) => {
            restful.Delete(`${state.study_environments_time_allocation_url}/${study_environment_time_allocation_id}/`)
                .then(response => {
                    commit(names.MUTATE_DELETE_STUDY_ENVIRONMENT_TIME_ALLOCATION, study_environment_time_allocation_id);
                    resolve(response);
                });
        });
    },
    // matter_study_environments
    [names.FETCH_MATTER_STUDY_ENVIRONMENTS]: ({
        commit,
        state
    }) => {
        return new Promise((resolve) => {
            restful.GetAll(`${state.matter_study_environments_url}/`)
                .then(response => {
                    commit(names.MUTATE_MATTER_STUDY_ENVIRONMENTS, response);
                    resolve(response);
                });
        });
    },
    [names.FETCH_MATTER_STUDY_ENVIRONMENT]: ({
        commit,
        state
    }, matter_id) => {
        return new Promise((resolve) => {
            restful.GetAll(`${state.matter_study_environments_url}/?matter__id=${matter_id}`)
                .then(response => {
                    commit(names.MUTATE_MATTER_STUDY_ENVIRONMENTS, response);
                    resolve(response);
                });
        });
    },
    [names.POST_MATTER_STUDY_ENVIRONMENT]: ({
        commit,
        state
    }, matter_study_environment) => {
        return new Promise((resolve) => {
            restful.Post(`${state.matter_study_environments_url}/`, matter_study_environment)
                .then(response => {
                    commit(names.MUTATE_MATTER_STUDY_ENVIRONMENT, response);
                    resolve(response);
                });
        });
    },
    [names.PATCH_MATTER_STUDY_ENVIRONMENT]: ({
        commit,
        state
    }, payload) => {
        return new Promise((resolve) => {
            restful.Patch(`${state.matter_study_environments_url}/${payload.id}/`, payload.data)
                .then(response => {
                    commit(names.MUTATE_MATTER_STUDY_ENVIRONMENT, response);
                    resolve(response);
                });
        });
    },
    [names.DELETE_MATTER_STUDY_ENVIRONMENT]: ({
        commit,
        state
    }, matter_study_environment_id) => {
        return new Promise((resolve) => {
            restful.Delete(`${state.matter_study_environments_url}/${matter_study_environment_id}/`)
                .then(response => {
                    commit(names.MUTATE_DELETE_MATTER_STUDY_ENVIRONMENT, matter_study_environment_id);
                    resolve(response);
                });
        });
    },
    // egress_profile_matter_study_environments
    [names.FETCH_EGRESS_PROFILE_MATTER_STUDY_ENVIRONMENTS]: ({
        commit,
        state
    }) => {
        return new Promise((resolve) => {
            restful.GetAll(`${state.egress_profile_matter_study_environments_url}/`)
                .then(response => {
                    commit(names.MUTATE_EGRESS_PROFILE_MATTER_STUDY_ENVIRONMENTS, response);
                    resolve(response);
                });
        });
    },
    [names.FETCH_EGRESS_PROFILE_MATTER_STUDY_ENVIRONMENT]: ({
        commit,
        state
    }, egress_profile_matter_id) => {
        return new Promise((resolve) => {
            restful.GetAll(`${state.egress_profile_matter_study_environments_url}/?egress_profile_matter__id=${egress_profile_matter_id}`)
                .then(response => {
                    commit(names.MUTATE_EGRESS_PROFILE_MATTER_STUDY_ENVIRONMENTS, response);
                    resolve(response);
                });
        });
    },
    [names.POST_EGRESS_PROFILE_MATTER_STUDY_ENVIRONMENT]: ({
        commit,
        state
    }, egress_profile_matter_study_environment) => {
        return new Promise((resolve) => {
            restful.Post(`${state.egress_profile_matter_study_environments_url}/`, egress_profile_matter_study_environment)
                .then(response => {
                    commit(names.MUTATE_EGRESS_PROFILE_MATTER_STUDY_ENVIRONMENT, response);
                    resolve(response);
                });
        });
    },
    [names.PATCH_EGRESS_PROFILE_MATTER_STUDY_ENVIRONMENT]: ({
        commit,
        state
    }, payload) => {
        return new Promise((resolve) => {
            restful.Patch(`${state.egress_profile_matter_study_environments_url}/${payload.id}/`, payload.data)
                .then(response => {
                    commit(names.MUTATE_EGRESS_PROFILE_MATTER_STUDY_ENVIRONMENT, response);
                    resolve(response);
                });
        });
    },
    [names.DELETE_EGRESS_PROFILE_MATTER_STUDY_ENVIRONMENT]: ({
        commit,
        state
    }, egress_profile_matter_study_environment_id) => {
        return new Promise((resolve) => {
            restful.Delete(`${state.egress_profile_matter_study_environments_url}/${egress_profile_matter_study_environment_id}/`)
                .then(response => {
                    commit(names.MUTATE_DELETE_EGRESS_PROFILE_MATTER_STUDY_ENVIRONMENT, egress_profile_matter_study_environment_id);
                    resolve(response);
                });
        });
    },
}

export default {
    state,
    getters,
    mutations,
    actions,
};